import React from "react";
import "./Wallet_History.css";

const Wallet_History = () => {
  const historyData = [
    { id: 1, price: "800", date: "12-08-2025", time: "12:30 AM" },
    { id: 2, price: "200", date: "10-05-2025", time: "10:30 AM" },
    { id: 3, price: "800", date: "12-08-2025", time: "12:30 AM" },
    { id: 4, price: "800", date: "12-08-2025", time: "12:30 AM" },
    { id: 5, price: "200", date: "10-05-2025", time: "10:30 AM" },
    { id: 6, price: "800", date: "12-08-2025", time: "12:30 AM" },
    { id: 7, price: "700", date: "10-05-2025", time: "10:30 AM" },
    { id: 8, price: "800", date: "12-08-2025", time: "12:30 AM" },
    { id: 9, price: "900", date: "12-08-2025", time: "12:30 AM" },
    { id: 10, price: "200", date: "10-05-2025", time: "10:30 AM" },
  ];
  return (
    <div className="wallet-history-container container">
      <h2 className="wallet-history-header">Wallet History</h2>

      <div className="wallet-history-list">
        {historyData.map((item) => (
          <div key={item.id} className="wallet-history-item">
            <div className="history-column">
              <span className="column-label">Price</span>
              <span className="column-value">₹{item.price}</span>
            </div>

            <div className="history-column text-center">
              <span className="column-label">Date</span>
              <span className="column-value">{item.date}</span>
            </div>

            <div className="history-column text-end">
              <span className="column-label">Time</span>
              <span className="column-value">{item.time}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Wallet_History;
